import React, { useState } from "react";
import { db, storage } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import "./UploadAd.css";

const categories = ["Furniture", "Electronics", "Bikes", "Fashion", "Books", "Other"];

const UploadAd = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [link, setLink] = useState("");
  const [timelineFrom, setTimelineFrom] = useState("");
const [timelineTo, setTimelineTo] = useState("");
  const [category, setCategory] = useState("Furniture");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [loading, setLoading] = useState(false);

const navigate = useNavigate();

  const handleImageChange = (file) => {
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) handleImageChange(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title || !description || !imageFile || !timelineFrom || !timelineTo || !category) {
  alert("Please fill all required fields (Title, Description, Image, Dates, Category)");
  return;
}

      

    setLoading(true);
    try {
      const storageRef = ref(storage, `adverts/${Date.now()}_${imageFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, imageFile);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(progress);
        },
        (error) => {
          console.error("Upload error:", error);
          alert("❌ Failed to upload image.");
          setLoading(false);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);

          await addDoc(collection(db, "Adverts"), {
            title,
            description,
            imageURL: downloadURL,
            link,
            category,
            timeline: `${timelineFrom} to ${timelineTo}`,
            createdAt: serverTimestamp(),
          });

          alert("✅ Ad uploaded successfully!");
          setTitle("");
          setDescription("");
          setImageFile(null);
          setImagePreview(null);
          setLink("");
          setCategory("Furniture");
          setTimelineFrom("");
          setTimelineTo("");
          setUploadProgress(0);
          setLoading(false);
        }
      );
    } catch (error) {
      console.error("Error uploading ad:", error);
      alert("❌ Failed to upload ad.");
      setLoading(false);
    }
  };

  return (
    <div className="upload-ad-page">
<div className="upload-ad-modal">
    <button
      className="close-upload-btn"
      onClick={() => navigate("/AdminDashboard")}
    >
      ❌
    </button>
      <h2>🚀 Upload New Advertisement</h2>
      <form className="upload-ad-form" onSubmit={handleSubmit}>
       <label>Title*</label>
        <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} required />

        <label>Description*</label>
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} required />

        <label>Drag & Drop Ad Image*</label>
        <div
          className="dropzone"
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
        >
          {imagePreview ? (
            <img src={imagePreview} alt="Preview" />
          ) : (
            <p>Drag & drop an image here, or click to select</p>
          )}
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageChange(e.target.files[0])}
            style={{ display: "none" }}
            id="fileUploadInput"
          />
        </div>

        {uploadProgress > 0 && loading && (
          <div className="upload-progress">
            <div className="upload-bar" style={{ width: `${uploadProgress}%` }}></div>
          </div>
        )}

        <label>Optional Link (e.g., to your website)</label>
        <input type="text" value={link} onChange={(e) => setLink(e.target.value)} />

        <label>Category*</label>
        <select value={category} onChange={(e) => setCategory(e.target.value)} required>
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>

        <label>From Date*</label>
<input
  type="date"
  value={timelineFrom}
  onChange={(e) => setTimelineFrom(e.target.value)}
  required
/>

<label>To Date*</label>
<input
  type="date"
  value={timelineTo}
  onChange={(e) => setTimelineTo(e.target.value)}
  required
/>


        <button type="submit" disabled={loading}>
          {loading ? "Uploading..." : "Upload Ad"}
        </button>
<button
  type="button"
  className="cancel-upload-adbtn"
  onClick={() => navigate("/AdminDashboard")}
>
  ❌ Cancel
</button>

      </form>
    </div>
</div>
  );
};

export default UploadAd;
